import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["hovered"];
import FormattedPropertyV2 from 'customer-data-properties/formatted/FormattedPropertyV2';
import { fullWidthCellClassName } from 'customer-data-properties/utils/fullWidthCellClassName';
import { parseMultiEnumValue } from 'customer-data-property-utils/parseMultiEnumValue';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { Clickable } from 'foundations-components/transitional/components/Clickable';
import { stopPropagationHandler } from 'foundations-components/transitional/utils/DomEvents';
import { useHovered } from 'foundations-components/transitional/utils/useHovered';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useIsManageButtonVisible } from '../hooks/useIsManageButtonVisible';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const alwaysUndefined = () => undefined;
const FileCell = ({
  objectTypeId,
  objectId,
  propertyDefinition,
  value,
  getSecondaryPropertyValue,
  onClick
}) => {
  const _useHovered = useHovered({}),
    {
      hovered
    } = _useHovered,
    hoveredProps = _objectWithoutPropertiesLoose(_useHovered, _excluded);
  const isManageButtonVisible = useIsManageButtonVisible({
    objectTypeId,
    objectId,
    propertyDefinition,
    hovered
  });
  const parsedValues = parseMultiEnumValue(value);
  const moreText = parsedValues.length > 1 ? /*#__PURE__*/_jsx(Text, {
    color: "text-core-subtle",
    as: "span",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "table.fileCell.more",
      options: {
        count: parsedValues.length - 1
      }
    })
  }) : null;
  return /*#__PURE__*/_jsx(Clickable, Object.assign({
    onClick: stopPropagationHandler
    // HACK: This is used to trigger the :has() CSS selector in
    // TruncateDiv.tsx without actually using a className which would
    // violate Trellis Migration rules.
    ,
    "data-classname": fullWidthCellClassName
  }, hoveredProps, {
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      inlineSize: "100%",
      minBlockSize: "30px",
      justifyContent: "space-between",
      children: [/*#__PURE__*/_jsx(FormattedPropertyV2, {
        "data-test-id": `formatted-property-${propertyDefinition.name}`,
        objectTypeId: objectTypeId,
        objectId: objectId,
        property: propertyDefinition,
        value: parsedValues[0],
        getDraftValue: getSecondaryPropertyValue,
        getSavedValue: alwaysUndefined,
        autoManageHighlySensitiveValue: false
      }), /*#__PURE__*/_jsx(Flex, {
        flexShrink: "0",
        children: isManageButtonVisible ? /*#__PURE__*/_jsx(Button, {
          use: "tertiary-light",
          size: "extra-small",
          onClick: onClick,
          "data-test-id": "file-cell-manage-button",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "table.fileCell.manage"
          })
        }) : moreText
      })]
    })
  }));
};
export default FileCell;